var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "height70" }, [_vm._v(" ")]),
          _vm._v(" "),
          _c("div", { staticClass: "cards-container" }, [
            _c("div", { staticClass: "title" }, [_vm._v("Text alignment")]),
            _vm._v(" "),
            _c("div", { staticClass: "col-4 text-alignment-left" }, [
              _c(
                "div",
                { staticClass: "cards-block" },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-2",
                      staticStyle: { "max-width": "20rem" },
                      attrs: {
                        title: "Left align",
                        "img-alt": "Image",
                        "img-top": "",
                        tag: "article"
                      }
                    },
                    [
                      _c("p", { staticClass: "card-text" }, [
                        _vm._v(
                          "\n                                Some quick example text to build on the card title and make up the bulk of the card's content.\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        { attrs: { href: "#", variant: "primary" } },
                        [_vm._v("Read More")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-4 text-alignment-center" }, [
              _c(
                "div",
                { staticClass: "cards-block" },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-2",
                      staticStyle: { "max-width": "20rem" },
                      attrs: {
                        title: "Center align",
                        "img-alt": "Image",
                        "img-top": "",
                        tag: "article"
                      }
                    },
                    [
                      _c("p", { staticClass: "card-text" }, [
                        _vm._v(
                          "\n                                Some quick example text to build on the card title and make up the bulk of the card's content.\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        { attrs: { href: "#", variant: "primary" } },
                        [_vm._v("Read More")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-4" }, [
              _c(
                "div",
                { staticClass: "cards-block text-alignment-right" },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-2",
                      staticStyle: { "max-width": "20rem" },
                      attrs: {
                        title: "Right align",
                        "img-alt": "Image",
                        "img-top": "",
                        tag: "article"
                      }
                    },
                    [
                      _c("p", { staticClass: "card-text" }, [
                        _vm._v(
                          "\n                                Some quick example text to build on the card title and make up the bulk of the card's content.\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        { attrs: { href: "#", variant: "primary" } },
                        [_vm._v("Read More")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "height70" }, [_vm._v(" ")]),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "height70" }, [_vm._v(" ")]),
          _vm._v(" "),
          _vm._m(3)
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Cards")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cards-container" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Card with Image")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "cards-block" }, [
          _c("div", { staticClass: "card" }, [
            _c("img", {
              staticClass: "card-img-top",
              attrs: {
                src: "static/images/cardsimg.jpg",
                alt: "Card with Image"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("h5", { staticClass: "card-title" }, [_vm._v("Card title")]),
              _vm._v(" "),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(
                  "Some quick example text to build on the card title and make up the bulk of the card's content."
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                { staticClass: "btn btn-primary", attrs: { href: "#" } },
                [_vm._v("Read More")]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "cards-block" }, [
          _c("div", { staticClass: "card" }, [
            _c("img", {
              staticClass: "card-img-top",
              attrs: {
                src: "static/images/cardsimg.jpg",
                alt: "Card with Image"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("h5", { staticClass: "card-title" }, [_vm._v("Card title")]),
              _vm._v(" "),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(
                  "Some quick example text to build on the card title and make up the bulk of the card's content."
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                { staticClass: "btn btn-primary", attrs: { href: "#" } },
                [_vm._v("Read More")]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "cards-block" }, [
          _c("div", { staticClass: "card" }, [
            _c("img", {
              staticClass: "card-img-top",
              attrs: {
                src: "static/images/cardsimg.jpg",
                alt: "Card with Image"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("h5", { staticClass: "card-title" }, [_vm._v("Card title")]),
              _vm._v(" "),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(
                  "Some quick example text to build on the card title and make up the bulk of the card's content."
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                { staticClass: "btn btn-primary", attrs: { href: "#" } },
                [_vm._v("Read More")]
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cards-container" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Card styles")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 text-alignment-left" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header card-header1" }, [
            _vm._v(
              "\n                            Card Title\n                        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("p", { staticClass: "card-text" }, [
              _vm._v(
                "With supporting text below as a natural lead-in to additional content."
              )
            ]),
            _vm._v(" "),
            _c("a", { staticClass: "btn btn-primary", attrs: { href: "#" } }, [
              _vm._v("Primary")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 text-alignment-left" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header card-header2" }, [
            _vm._v(
              "\n                            Card Title\n                        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("p", { staticClass: "card-text" }, [
              _vm._v(
                "With supporting text below as a natural lead-in to additional content."
              )
            ]),
            _vm._v(" "),
            _c("a", { staticClass: "btn btn-primary", attrs: { href: "#" } }, [
              _vm._v("Primary")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 text-alignment-left" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header card-header3" }, [
            _vm._v(
              "\n                            Card Title\n                        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("p", { staticClass: "card-text" }, [
              _vm._v(
                "With supporting text below as a natural lead-in to additional content."
              )
            ]),
            _vm._v(" "),
            _c("a", { staticClass: "btn btn-primary", attrs: { href: "#" } }, [
              _vm._v("Primary")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 text-alignment-left" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header card-header4" }, [
            _vm._v(
              "\n                            Card Title\n                        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("p", { staticClass: "card-text" }, [
              _vm._v(
                "With supporting text below as a natural lead-in to additional content."
              )
            ]),
            _vm._v(" "),
            _c("a", { staticClass: "btn btn-primary", attrs: { href: "#" } }, [
              _vm._v("Primary")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cards-container" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Card with Image")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "cards-block" }, [
          _c("div", { staticClass: "card" }, [
            _c("img", {
              staticClass: "card-img-top",
              attrs: {
                src: "static/images/card-with-deck1.jpg",
                alt: "Card with Deck"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("h5", { staticClass: "card-title" }, [_vm._v("Card title")]),
              _vm._v(" "),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(
                  "This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit "
                )
              ]),
              _vm._v(" "),
              _c("small", [_vm._v("Last updated 3 mins ago")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "cards-block" }, [
          _c("div", { staticClass: "card" }, [
            _c("img", {
              staticClass: "card-img-top",
              attrs: {
                src: "static/images/card-with-deck1.jpg",
                alt: "Card with Deck"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("h5", { staticClass: "card-title" }, [_vm._v("Card title")]),
              _vm._v(" "),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(
                  "This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit "
                )
              ]),
              _vm._v(" "),
              _c("small", [_vm._v("Last updated 3 mins ago")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "cards-block" }, [
          _c("div", { staticClass: "card" }, [
            _c("img", {
              staticClass: "card-img-top",
              attrs: {
                src: "static/images/card-with-deck1.jpg",
                alt: "Card with Deck"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("h5", { staticClass: "card-title" }, [_vm._v("Card title")]),
              _vm._v(" "),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(
                  "This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit "
                )
              ]),
              _vm._v(" "),
              _c("small", [_vm._v("Last updated 3 mins ago")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69c44a03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c44a03","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards.vue
// module id = null
// module chunks = 